import {Component, Input} from "@angular/core";
import {ReportModel} from "@fedeltapointofsale/data-client";
import {EditService} from "../../../framework/entity/edit/edit-page/edit.service";

@Component({
    selector: "wbo-single-date-report-criteria",
    templateUrl: "./single-date-report-criteria.component.html"
})
export class SingleDateReportCriteriaComponent {

    @Input() fromDateField: string = "startDate";
    @Input() dateRangePeriodField: string = "dateRangePeriod";
    @Input() disabled: boolean = false;

    constructor(public model: ReportModel<any>, public editService: EditService) {
    }
}
